import { CUSTOMERS, CUSTOMERS_SUCCESS, CUSTOMERS_FAIL } from "./actionTypes";

const initialState = {
  error: null,
  data: null,
  loading: false,
};

const customers = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOMERS:
    case CUSTOMERS_SUCCESS:
    case CUSTOMERS_FAIL:
      state = {
        ...state,
        ...action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default customers;
